import React, { Component } from 'react';
import FormError from '../../models/FormError';
import ErrorFieldMessage from './FieldErrorMessage.Component';

type DateInputFieldProps = {
    name: string,
    label?: string,
    placeholder: string,
    value?: string,
    errors?: FormError[],
    id: string,
    autocomplete?: string,

    onChange: (name: string, value: Date) => Promise<FormError[]>,
}

type DateInputFieldState = {
    value: string,
    date: Date,
    errors: FormError[]
}

export default class DateInputField extends Component<DateInputFieldProps, DateInputFieldState> {
    constructor(props: DateInputFieldProps) {
        super(props);

        this.state = {
            value: "",
            date: props.value ? new Date(Date.parse(props.value)) : new Date(),
            errors: props.errors?.filter(err => { return err.field === props.name }) ?? []
        }
    }

    public componentDidUpdate(previousProps: DateInputFieldProps, previousState: DateInputFieldState) {
        if (this.props.errors?.length != previousProps.errors?.length) {
            this.setState({
                errors: this.props.errors?.filter(err => { return err.field === this.props.name }) ?? [],
            });
        }

        if (this.props.value && this.props.value != previousProps.value) {
            const dateParts: string[] = this.props.value.split('/');
            if (dateParts.length === 3) {
                const year = parseInt(dateParts[2]);
                const month = parseInt(dateParts[1]);
                const day = parseInt(dateParts[0]);
                const date = new Date(year, month, day, 0, 0, 0, 0);
                this.setState({
                    date: date,
                    value: this.props.value
                });
            }
        }
    }

    public async onSetValue(value: string) {
        if (value == '') {
            return;
        }

        const dateParts: string[] = value.split('/');
        let date: Date = new Date(9999, 1, 1);
        if (dateParts.length === 3) {
            const year = parseInt(dateParts[2]);
            const month = parseInt(dateParts[1]);
            const day = parseInt(dateParts[0]);
            date = new Date(year, month - 1, day, 0, 0, 0, 0);
        }

        const errors = await this.props.onChange(this.props.name, date);

        this.setState({
            value: value,
            date: date,
            errors: errors
        })
    }

    public format(value: string) {
        const numbersRegex: RegExp = /[0-9]/mg;
        const matches = value.match(numbersRegex);
        let result = '';

        if (value.length > this.state.value.length) {

            if (matches && matches.length) {
                matches.forEach((val, i) => {
                    if (i < 8) {
                        result = result + val;
                    }

                    if ((i === 1 && (matches.length > 2)) ||
                        (i === 3 && (matches.length > 4))) {
                        result = result + '/';
                    }
                });
            }
            this.setState({
                value: result,
            });
        }
        else {
            this.setState({
                value: value
            })
        }
    }

    public render() {
        return <div className="form-group">
            {this.props.label &&
                <label htmlFor={this.props.id}>{this.props.label}</label>
            }

            <input
                id={this.props.id}
                name={this.props.name}
                placeholder={this.props.placeholder}
                value={this.state.value}
                className={"form-control" + (this.state.errors.length > 0 ? " is-invalid" : "")}
                autoComplete={this.props.autocomplete}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.format(event.target.value)
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.onSetValue(event.target.value)
                }} />
            <ErrorFieldMessage name={this.props.name} errors={this.state.errors}></ErrorFieldMessage>
        </div>
    }
}